import Cookies from "js-cookie";
const token = "token";
export function getToken() {
  return Cookies.get(token);
}
export function setToken(e) {
  Cookies.set(token, e);
}
export function removeToken() {
  Cookies.remove(token);
}



// WEBPACK FOOTER //
// ./src/util/cookie.js